module.exports = __webpack_public_path__ + "media/images/review/star_3-86292a137b01a02658c5f4b10e2ee997.svg";